import { gql } from "@apollo/client";

export const DELETE_SUSPENSION = gql`
    mutation RemoveSuspension (
        $idSuspension: Int!,
        $idEvaluacion: Int!
    ){
        removeSuspension (
            idSuspension: $idSuspension,
            idEvaluacion: $idEvaluacion
        ){
            idEvaluacion
        }
    }
`;